import Repository from '@/repositories/marketing'
const resource = '/sms_lists'
const smsContactResource='sms_contacts'

export default {
	fetch(config) {
		return Repository.get(`${resource}.json`,config)
	},
	create(payload) {
		return Repository.post(`${resource}.json`, payload)
	},
	edit(listId, payload) {
		return Repository.put(`${resource}/${listId}.json`, payload)
	},
	getSelectedContact(contactId) {
		return Repository.get(`${resource}/${contactId}.json`)
	},
	export(listId) {
		return Repository.get(`${resource}/${listId}/export.json`)
	},
	readImportedFile(listId, payload, config) {
		return Repository.post(`${resource}/${listId}/read_imported_file.json`, payload, config)
	},
	import(listId, payload) {
		return Repository.post(`${resource}/${listId}/import.json`, payload)
	},
	delete(listId) {
		return Repository.delete(`${resource}/${listId}.json`)
	},
	getAllSmsContacts(listId, config) {
		return Repository.get(`${resource}/${listId}/sms_contacts.json`, config)
	},
	saveSmsContact(listId, payload, config) {
		return Repository.post(`${resource}/${listId}/${smsContactResource}.json`, payload, config)
	},
	createList (payload, config) {
		return Repository.post(`${resource}.json`, payload, config)
	},
	updateSmsContact(listId, contactId, payload) {
		let url = `${resource}/${listId}/${smsContactResource}/${contactId}.json`;
		if(typeof listId === 'undefined') url = `sms_contacts/${contactId}.json`;
		return Repository.put(url, payload);
	},
	importStatus(listId) {
		return Repository.get(`${resource}/${listId}/import_status.json`)
	},
	deleteSmsListContacts(listId, contactId){
		return Repository.delete(`${resource}/${listId}/${smsContactResource}/${contactId}.json`)
	},
	fetchSMSCampaignVolume(listId, payload) { 
		return Repository.get(`${resource}/${listId}/sms_campaign_volume.json`, payload)
	},
	getCampaignLists(listId){
		return Repository.get(`${resource}/${listId}/sms_campaign_lists.json`)
	},
}